import { render, staticRenderFns } from "./ContentFilesEditTabContent.vue?vue&type=template&id=6bcad7ac&"
import script from "./ContentFilesEditTabContent.vue?vue&type=script&lang=js&"
export * from "./ContentFilesEditTabContent.vue?vue&type=script&lang=js&"
import style0 from "./ContentFilesEditTabContent.vue?vue&type=style&index=0&id=6bcad7ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports